import { render } from "./ContentKI.vue?vue&type=template&id=d211ea16&scoped=true&ts=true"
import script from "./ContentKI.vue?vue&type=script&lang=ts"
export * from "./ContentKI.vue?vue&type=script&lang=ts"

import "./ContentKI.vue?vue&type=style&index=0&id=d211ea16&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d211ea16"]])

export default __exports__